import React, { useState, useEffect } from "react";
import axios from "axios";
import styled from "styled-components";
import { toast } from "react-toastify";
import Moment from "react-moment";
import { SmallPrint, FormRow, FormSelect, Alert, BlockButton, PenceToPounds } from "fiver-react-ui-components";
const StyledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 0;
  font-size: 0.875rem;
  margin: 1.5rem 0 1.5rem;
`;
const StyledLabel = styled.div`
  margin-bottom: 0.325rem;
  font-size: 0.75rem;
  text-align: center;
  color: ${props => props.theme.colorLabel};
`;
const StyledValue = styled.div`
  text-align: center;
  font-weight: 700;
`;

const WalletButtonsDepositLimit = ({
  onError,
  translations,
  currencySymbol,
  dateLocale
}) => {
  const [isSaving, setSaving] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const [depositLimit, setDepositLimit] = useState({});
  const [form, setForm] = useState({
    depositLimitAmount: undefined,
    depositLimitDuration: undefined
  });
  const {
    depositLimitAmount,
    depositLimitDuration
  } = form;
  const hasPendingLimit = depositLimit?.pending ? true : undefined;
  const depositLimitToShow = hasPendingLimit === true && depositLimit ? depositLimit?.pending : depositLimit?.active;
  const formIsValid = depositLimitToShow && depositLimitToShow.amount !== depositLimitAmount || depositLimitToShow && depositLimitToShow.duration !== depositLimitDuration;
  const shouldShowForm = depositLimitToShow && depositLimitToShow.amount === null || hasPendingLimit && depositLimit.pending.amount === null;
  const shouldShowRemove = depositLimitToShow && depositLimitToShow.amount !== null;
  const shouldShowSave = hasPendingLimit && depositLimit.pending.amount === null || !hasPendingLimit && depositLimitToShow && depositLimitToShow.amount === null;

  const saveDepositLimit = async params => {
    setSaving(true);

    try {
      const depositLimitRes = await axios.put(`/wallet/deposit-limit`, params);
      setSaving(false);
      setDepositLimit(depositLimitRes?.data?.data);
      toast.success(translations.depositLimitUpdated);
    } catch (error) {
      setSaving(false);
      toast.error(translations.depositLimitError);
    }
  };

  const handleTextboxChanged = e => {
    const {
      value,
      name
    } = e.target;
    setForm({ ...form,
      [name]: value
    });
  };

  const handleSelectChanged = e => {
    const {
      value,
      name
    } = e.target;
    setForm({ ...form,
      [name]: +value
    });
  };

  useEffect(() => {
    if (!depositLimitAmount && depositLimit) {
      setForm({ ...form,
        depositLimitAmount: depositLimit.amount,
        depositLimitDuration: depositLimit.duration
      });
    }
  }, [depositLimit]);
  useEffect(() => {
    (async () => {
      try {
        const depositLimitRes = await axios.get(`/wallet/deposit-limit`);
        setDepositLimit(depositLimitRes?.data?.data);
        setLoading(false);
      } catch ({
        response
      }) {
        setLoading(false);
        onError(response);
      }
    })();
  }, []);
  console.log(depositLimit);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SmallPrint, null, translations.depositLimitMessage)), depositLimit && depositLimit.active && /*#__PURE__*/React.createElement(StyledRow, null, depositLimit && depositLimit.active && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledLabel, null, translations.yourCurrentLimit), /*#__PURE__*/React.createElement(StyledValue, null, currencySymbol, /*#__PURE__*/React.createElement(PenceToPounds, null, depositLimit.active.amount), "/", " ", depositLimit.active.duration === 1 ? "day" : depositLimit.active.duration === 7 ? "week" : "month")), depositLimit && depositLimit.pending && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(StyledLabel, null, translations.yourPendingLimit), /*#__PURE__*/React.createElement(StyledValue, null, currencySymbol, /*#__PURE__*/React.createElement(PenceToPounds, null, depositLimit.pending.amount), "/", " ", depositLimit.pending.duration === 1 ? translations.day : depositLimit.pending.duration === 7 ? translations.week : translations.month))), hasPendingLimit && depositLimitToShow && /*#__PURE__*/React.createElement(Alert, {
    margin: "0 0 1rem"
  }, translations.limitWillTakeEffect, " ", depositLimitToShow && depositLimitToShow.effectiveFrom && /*#__PURE__*/React.createElement(Moment, {
    locale: dateLocale || "en-gb",
    date: depositLimitToShow.effectiveFrom,
    format: "DD/MM/YYYY [at] h:mm:ss a"
  })), shouldShowForm && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormSelect, {
    name: "depositLimitAmount",
    value: depositLimitAmount,
    onChange: handleSelectChanged
  }, /*#__PURE__*/React.createElement("option", {
    value: 1000
  }, currencySymbol, "10"), /*#__PURE__*/React.createElement("option", {
    value: 2000
  }, currencySymbol, "20"), /*#__PURE__*/React.createElement("option", {
    value: 3000
  }, currencySymbol, "30"), /*#__PURE__*/React.createElement("option", {
    value: 4000
  }, currencySymbol, "40"), /*#__PURE__*/React.createElement("option", {
    value: 5000
  }, currencySymbol, "50"), /*#__PURE__*/React.createElement("option", {
    value: 7500
  }, currencySymbol, "75"), /*#__PURE__*/React.createElement("option", {
    value: 10000
  }, currencySymbol, "100"), /*#__PURE__*/React.createElement("option", {
    value: 20000
  }, currencySymbol, "200"), /*#__PURE__*/React.createElement("option", {
    value: 30000
  }, currencySymbol, "300"), /*#__PURE__*/React.createElement("option", {
    value: 40000
  }, currencySymbol, "400"), /*#__PURE__*/React.createElement("option", {
    value: 50000
  }, currencySymbol, "500"))), /*#__PURE__*/React.createElement(FormRow, null, /*#__PURE__*/React.createElement(FormSelect, {
    name: "depositLimitDuration",
    value: depositLimitDuration,
    onChange: handleSelectChanged
  }, /*#__PURE__*/React.createElement("option", {
    value: 1
  }, "1 ", translations.day), /*#__PURE__*/React.createElement("option", {
    value: 7
  }, "7 ", translations.days), /*#__PURE__*/React.createElement("option", {
    value: 28
  }, "28 ", translations.days)))), shouldShowRemove && /*#__PURE__*/React.createElement(BlockButton, {
    size: "sm",
    disabled: isSaving,
    isLoading: isSaving,
    isDanger: true,
    onClick: () => saveDepositLimit({
      amount: null,
      duration: null
    })
  }, translations.remove, " ", translations.limit), shouldShowSave && /*#__PURE__*/React.createElement(BlockButton, {
    disabled: !formIsValid || isSaving,
    isLoading: isSaving,
    onClick: () => saveDepositLimit({
      amount: depositLimitAmount || 1000,
      duration: depositLimitDuration || 1
    }),
    size: "sm"
  }, translations.save));
};

export default WalletButtonsDepositLimit;